import { createRouter, RouterProvider } from '@tanstack/react-router';
// eslint-disable-next-line import/extensions
import { routeTree } from './routeTree.gen';
import { useAuthenticated } from './providers/authenticated';

const router = createRouter({
  routeTree,
  context: {
    isAuthenticated: null,
  },
  defaultPendingMs: 0,
  defaultGcTime: 0,
});

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

export const ProtectedApp = () => {
  const { isAuthenticated } = useAuthenticated();

  return (
    <RouterProvider
      defaultPreload="intent"
      context={{ isAuthenticated }}
      router={router}
    />
  );
};
